import { guardClient } from '../_axios'

export const restoreTask = async (id: string) => {
  const response = await guardClient.patch(`/tasks/${id}/restore`)
  return response.data
}
